//return console.warn('JS disabled for testing.');

//
// Load helpers into global namespace
//

require('helpers');


//
// Init Widgets and Controllers
//

var Widgets     = require('./widgets');
var Controllers = require('./controllers');

Widgets.initAllWithin(document);
Controllers.initAllWithin(document);

